import { useCopyToClipboard } from '@modules/common/hooks';
import { getTenantSlugFromURL } from '@modules/common/utils';
import { getAnalysisTypeDisplayName } from '@modules/dashboard/helpers';
import { trackWisdomEvents } from '@modules/oracle/utils';
import { LinkRounded, OpenInNewRounded } from '@mui/icons-material';
import { Button, IconButton, Link, Stack } from '@mui/material';
import { AnalysisViewFragment } from 'generated/graphql';
import { getAnalysisLink } from 'v2/core/services/analysis/link';

interface ArtefactCitationFeedbackListPopoverHeaderActionsProps {
  analysis: AnalysisViewFragment;
}

export const ArtefactCitationFeedbackListPopoverHeaderActions = ({
  analysis,
}: ArtefactCitationFeedbackListPopoverHeaderActionsProps) => {
  const copyToClipboard = useCopyToClipboard();

  const analysisLink = getAnalysisLink({
    name: analysis.title,
    tenantSlug: getTenantSlugFromURL(),
    token: analysis.viewToken,
    useCase: analysis.useCase,
  });

  const copyArtefactLink = () => {
    copyToClipboard(analysisLink, 'Link copied to clipboard!');
    trackWisdomEvents({
      eventName: 'Wisdom - Copied Artefact Link from Feedback Citation View',
      artefact: {
        id: analysis.id,
        title: analysis.title,
        useCase: analysis.useCase,
        link: analysisLink,
      },
    });
  };

  return (
    <Stack direction="row" alignItems="center">
      <IconButton color="primary" onClick={copyArtefactLink} size="small">
        <LinkRounded />
      </IconButton>
      <Button
        variant="outlined"
        color="primary"
        size="small"
        endIcon={<OpenInNewRounded />}
        LinkComponent={Link}
        href={analysisLink}
        target="_blank"
        sx={{
          minWidth: 'max-content',
          whiteSpace: 'nowrap',
        }}
        onClick={() => {
          trackWisdomEvents({
            eventName:
              'Wisdom - Opened Artefact Page from Feedback Citation View',
            artefact: {
              id: analysis.id,
              title: analysis.title,
              useCase: analysis.useCase,
              link: analysisLink,
            },
          });
        }}
      >
        Open {getAnalysisTypeDisplayName(analysis.useCase)}
      </Button>
    </Stack>
  );
};
